export const fbConfig = {
	apiKey: "AIzaSyDJSi4T479RKUW_sl10jOm4_fFBU7iMu3c",
	authDomain: "sevens-legal.firebaseapp.com",
	projectId: "sevens-legal",
	storageBucket: "sevens-legal.firebasestorage.app",
	messagingSenderId: "807796031667",
	appId: "1:807796031667:web:721d8887ba707d98d9f0c6"
};
